import styled from 'styled-components';

const FolderOpenIconSvg = styled.svg`
  width: 14px;
  height: 12px;
  flex-shrink: 0;
  color: var(--text-secondary);
`;

export default function FolderOpenIcon() {
  return (
    <FolderOpenIconSvg viewBox="3 3 19 17" fill="none" aria-hidden="true">
      <path
        d="M5 19l2.757 -7.351a1 1 0 0 1 .936 -.649h12.307a1 1 0 0 1 .986 1.164l-.996 5.211a2 2 0 0 1 -1.986 1.625h-14.004a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v2"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </FolderOpenIconSvg>
  );
}
